// extracted by mini-css-extract-plugin
module.exports = {"exportClientsDataModelStyle":"_1RZqgoLrf__tTv8Rf4Fjnx"};